import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import PagoPage from './Pago';
import React from 'react';

const ROUTES = [<LayoutRoute exact={true} path="/pago" layout={HomePublicaLayout} component={PagoPage} />];

const POLIZAS_ROUTES = ROUTES;

export default POLIZAS_ROUTES;
